// extracted by mini-css-extract-plugin
module.exports = {"modalCloseButton":"modal-close-button_component_modalCloseButton__DFEZk"};